import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import styles from "./pelak.module.css";
import alphabet from "../../constant-value/alphaet.json";

const Pelak = ({ part1Pelak, part2Pelak, part3Pelak, part4Pelak }) => {
  const part1 = part1Pelak;
  // const letter = alphabet.filter((auto) => auto.id == part2Pelak);
  const letter = alphabet.find(
    (item) => String(item.id) === String(part2Pelak)
  );
  const part3 = part3Pelak;
  const iranCode = part4Pelak;

  return (
    <div className={styles["pelak"]}>
      {/* ستون آبی سمت چپ */}
      <div className={styles["pelak-blue"]}>
        <div className={styles["pelak-flag"]}>
          <div className={styles["flag-green"]}></div>
          <div className={styles["flag-white"]}></div>
          <div className={styles["flag-red"]}></div>
        </div>
        <div className={styles["pelak-text"]}>
          <span className={styles["ir"]}>I.R.</span>
          <span className={styles["iran"]}>IRAN</span>
        </div>
      </div>

      {/* عدد و حرف وسط پلاک */}
      <div className={styles["pelak-main"]}>
        <span className={styles["pelak-num"]}>{part1}</span>
        {/* <span className={styles["pelak-letter"]}>{letter[0].name}</span> */}
        <span className={styles.pelak-letter}>
          {letter?.name ?? ""}
        </span>
        <span className={styles["pelak-num"]}>{part3}</span>
      </div>

      {/* ستون ایران سمت راست */}
      <div className={styles["pelak-iran-col"]}>
        <span className={styles["iran-word"]}>ایران</span>
        <strong className={styles["iran-code"]}>{iranCode}</strong>
      </div>
    </div>
  );
};

export default Pelak;